import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tours',
  templateUrl: './tours.component.html',
  styleUrls: ['./tours.component.scss']
})
export class ToursComponent implements OnInit {

  bannerTitulo = 'Encuentra tu tour';
  bannerContenido = "Desde aquí podrás encontrar todos los tours en función de la ubicación seleccionada";
  bannerMargen = false;
  bannerImagen="assets/search.jpg"
 

  constructor() { }

  ngOnInit(): void {
  }

}
